import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { HeightWatcherDirective } from '../../height-watcher.directive';
import { LayoutService } from '../../shared/services/layout.service';
import { UserImageAndNameDisplayComponent } from './user-image-and-name-display/user-image-and-name-display.component';
import IpadPackage = PRM.IpadPackage;

@Component({
  selector: 'app-observer-conference',
  templateUrl: './observer-conference.component.html',
  styleUrls: ['./observer-conference.component.css'],
  imports: [
    CommonModule,
    HeightWatcherDirective,
    RouterLinkActive,
    RouterLink,
    UserImageAndNameDisplayComponent,
    RouterOutlet
  ],
  standalone: true
})
export class ObserverConferenceComponent {
  public pack: IpadPackage;

  constructor(private aRoute: ActivatedRoute, public layoutService: LayoutService) {
    aRoute.data.subscribe((data) => {
      this.pack = data.pack;
    });
  }
}